import * as THREE from 'three'
import { Trail } from '@react-three/drei'
import { GroupProps, MeshProps, useFrame } from '@react-three/fiber'
import { useEffect, useRef } from 'react'
import { Mesh, MeshBasicMaterial, Vector3 } from 'three'
import TWEEN from '@tweenjs/tween.js'

const fireMagic = {
  trainColor: 'orange',
  ballColor: 'red',
}
const iceMagic = {
  trainColor: 'lightblue',
  ballColor: 'cyan',
}
const defaultOrigin = new Vector3(-10, 2, 0)
const defaultDestination = new Vector3(0, 2, 0)

export default function Electron({
  radius = 2.75,
  speed = 6,
  origin,
  destination,
  onComplete,
  ...props
}: {
  radius?: number
  speed?: number
  origin?: Vector3
  destination?: Vector3
  onComplete: () => void
} & GroupProps) {
  const ref = useRef<Mesh>(null)
  useEffect(() => {
    if (origin && destination && ref.current && !ref.current!.visible) {
      ref.current!.visible = true
      ref.current.scale.set(1, 1, 1)
      ref.current.position.copy(origin)
      const mat = ref.current?.material as MeshBasicMaterial
      const travel = new TWEEN.Tween(ref.current.position)
        .to(
          {
            x: destination.x,
            // y: destination.y,
            z: destination.z,
          },
          1000,
        )
        .onUpdate((position: Vector3, elapsed) => {
          position.y = destination.y + Math.sin(Math.PI * elapsed) * 1.5
        })
        .easing(TWEEN.Easing.Sinusoidal.In)
        .onStart(() => {})
      // .delay(4000)
      const diminish = new TWEEN.Tween(ref.current.scale)
        .to(
          {
            x: 0,
            y: 0,
            z: 0,
          },
          150,
        )
        .easing(TWEEN.Easing.Linear.None)
      const explode = new TWEEN.Tween(ref.current.scale)
        .to(
          {
            x: 5,
            y: 5,
            z: 5,
          },
          300,
        )
        .easing(TWEEN.Easing.Exponential.Out)
        .onUpdate((scale, elapsed) => {
          mat.opacity = 1 - elapsed
        })
        .onComplete(() => {
          ref.current!.visible = false
          onComplete()
        })
      travel.chain(diminish)
      diminish.chain(explode)
      travel.start()
    }
  }, [origin, destination, onComplete])
  const magicConfig = iceMagic
  return (
    <group {...props}>
      <Trail local width={5} length={6 / 2} color={magicConfig.trainColor} attenuation={t => t * t}>
        <mesh ref={ref} visible={false}>
          <sphereGeometry args={[0.25]} />
          <meshBasicMaterial color={magicConfig.ballColor} toneMapped={false} transparent />
        </mesh>
      </Trail>
    </group>
  )
}
